import React, { useState } from 'react';
import Box from '@mui/material/Box/Box';
import Typography from '@mui/material/Typography/Typography';

import { isLocal, levels } from 'consts';
import { RemoteLevelTile } from './RemoteLevelTile';

import type { RemoteLevel } from 'types';
import { MoreToolsModal } from '../MoreToolsModal';

type RemoteLevelMenuProps = {
  changeSelectedRemoteLevel: (remoteLevel: RemoteLevel) => void;
  remoteLevel: RemoteLevel | null;
};

const WAS_MORE_TOOLS_MODAL_SUBMITTED = 'WAS_MORE_TOOLS_MODAL_SUBMITTED';

export const RemoteLevelMenu = ({
  changeSelectedRemoteLevel,
  remoteLevel,
}: RemoteLevelMenuProps) => {
  const [openedLevels, setOpenedLevels] = useState<number[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onModalClose = () => {
    setIsModalOpen(false);
  };
  const onModalOpen = () => setIsModalOpen(true);

  const handleChangeSelectedRemoteLevel = (level: RemoteLevel) => {
    if (JSON.stringify(level) !== JSON.stringify(remoteLevel)) {
      changeSelectedRemoteLevel(level);
    }
  };

  const toggleRemoteLevel = (level: RemoteLevel) => {
    if (level.level === 6 && !isLocal) {
      let wasMoreToolsModalSubmitted: string | null;

      try {
        wasMoreToolsModalSubmitted = localStorage.getItem(
          WAS_MORE_TOOLS_MODAL_SUBMITTED
        );
      } catch {
        wasMoreToolsModalSubmitted = null;
      }

      if (wasMoreToolsModalSubmitted !== 'true') {
        onModalOpen();
        return;
      }
    }
    const filteredLevels = openedLevels.filter(
      (openedLevel) => openedLevel !== level.level
    );

    if (filteredLevels.length === openedLevels.length) {
      setOpenedLevels((prev) => [...prev, level.level]);
    } else {
      setOpenedLevels(filteredLevels);
    }
  };

  const isSelected = (newRemoteLevel: RemoteLevel) => {
    if (remoteLevel?.isCustom) return newRemoteLevel.isCustom;

    return (
      !newRemoteLevel.isCustom &&
      newRemoteLevel.allowedOverlap === remoteLevel?.allowedOverlap
    );
  };

  return (
    <>
      <Box display="flex" flexDirection="column">
        <Typography
          variant="textMedium"
          color="text.secondary"
          mb={5}
          fontWeight={500}
        >
          Select your remote work preference
        </Typography>
        <Box display="flex" flexDirection="column">
          {levels.map((remoteLevel) => (
            <RemoteLevelTile
              key={remoteLevel.level}
              level={remoteLevel}
              isSelected={isSelected(remoteLevel)}
              isOpened={openedLevels.includes(remoteLevel.level)}
              changeSelectedRemoteLevel={handleChangeSelectedRemoteLevel}
              toggleRemoteLevel={toggleRemoteLevel}
            />
          ))}
        </Box>
      </Box>

      <MoreToolsModal
        isOpen={isModalOpen}
        onClose={onModalClose}
        onSubmitted={() => {
          localStorage.setItem(WAS_MORE_TOOLS_MODAL_SUBMITTED, String(true));
        }}
      />
    </>
  );
};
